import { OptionsState } from './options.types';

export const preloadedOptionsState: OptionsState = {
  options: null,
  loading: false,
  employeesLoading: false,
};
